import styled from 'styled-components';

export default styled.div`
  .textField-area-wrap {
    height: auto;
    textarea {
      padding-top: 10px;
    }
  }
  .Mui-disabled {
    color: #ccc !important;
  }

  .css-123nw5d-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {
    border: 1px solid #ccc;
  }
  label.css-1g02fr1-MuiFormLabel-root-MuiInputLabel-root {
    padding-left: 8px;
    padding-right: 10px;
    background: #fff;
  }
  .ant-cascader-picker-label {
    /* max-width: 125px; */
    /* padding-right:0; */
  }
  .ant-input {
    display: flex;
    padding-left: 0px;
    height: 30px;
  }
  .ant-cascader-picker {
    color: currentColor;
  }
  .ant-input.ant-cascader-input {
    color: currentColor !important;
  }
  /* .css-1moarqh-MuiFormControlLabel-root {
    color: #000;
  } */
`;
